// extracted by mini-css-extract-plugin
export var Layout = "Layout-module--Layout--yNDr3";